<template>
    <div v-cloak class="row row-sm border-top">
        <!-- Thumbnail -->
        <div class="col-3 col-sm-2 col-md-1 col-lg-1 col-xl-1">
            <a :href="item.variant.url" class="d-block">
                <img :src="item.variant.thumbnail"
                     :alt="item.variant.name"
                     class="img-fluid"
                >
            </a>
        </div>

        <!-- Details -->
        <div class="col-9 col-sm-10 col-md-3 col-lg-5 col-xl-6">
            <a :href="item.variant.url" class="lead text-darker" v-text="item.variant.name" />
            <br>
            <span class="text-muted" v-text="item.variant.product_id" />
            <br>
            <span class="badge badge-secondary" v-text="item.variant.description" />
        </div>

        <!-- Quantity -->
        <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-2 d-flex align-items-center border-top border-bottom border-md-0" :class="{ 'has-error': item.error }">
            <div class="form-group row flex-fill mb-0">
                <label class="col col-form-label d-md-none text-muted" :for="`items.${item.id}.quantity`">
                    Ποσότητα
                </label>

                <div class="col input-group">
                    <span class="input-group-prepend">
                        <button class="btn btn-secondary font-weight-bold" type="button" @click="decrement">&minus;</button>
                    </span>
                    <input
                        :id="`items.${item.id}.quantity`"
                        type="number"
                        :name="`items[${item.id}][quantity]`"
                        :min="min"
                        :max="max"
                        step="1"
                        class="form-control"
                        :class="{ 'is-invalid' : item.error }"
                        :value="quantity"
                        @input="update($event.target.value)"
                    >
                    <span class="input-group-append">
                        <button class="btn btn-secondary font-weight-bold" type="button" @click="increment">+</button>
                    </span>
                </div>

                <input type="hidden"
                       :class="{ 'is-invalid' : item.error }"
                       :name="`items[${item.id}][id]`"
                       :value="item.id"
                >
                <div class="col-12 invalid-feedback text-right text-md-left"
                     v-text="item.error"
                />
            </div>
        </div>

        <!-- Price -->
        <div class="col-12 col-md-2 col-lg-1 col-xl-1 d-flex align-items-center cart-item-footer">
            <div class="d-md-none text-muted">
                Τιμή προϊόντος
            </div>

            <div class="d-flex flex-md-column ml-auto text-right">
                <s v-if="item.sale > 0" class="text-muted">{{ item.price | money }}</s>
                <span class="ml-2" :class="{ 'text-success': item.sale > 0 }">{{ offer | money }}</span>
            </div>
        </div>

        <!-- Total -->
        <div class="col-12 col-md-2 col-lg-1 col-xl-1 d-flex align-items-center cart-item-footer">
            <div class="d-md-none text-muted">
                Σύνολο προϊόντος
            </div>

            <div class="d-flex flex-md-column ml-auto text-right">
                <s v-if="item.sale > 0" class="text-muted">{{ item.price * quantity | money }}</s>
                <span class="ml-2" :class="{ 'text-success': item.sale > 0 }">{{ total | money }}</span>
            </div>
        </div>

        <!-- Remove from cart -->
        <div class="col-12 col-md-1 border-left-md d-flex align-items-center cart-item-footer">
            <div class="d-md-none text-muted">
                Αφαίρεση από το καλάθι
            </div>

            <button
                class="btn btn-sm btn-secondary ml-auto font-weight-bold"
                type="submit"
                :name="`items[${item.id}][quantity]`"
                value="0"
                data-toggle="tooltip"
                data-placement="top"
                title="Αφαίρεση από το καλάθι"
            >
                &times;
            </button>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    quantity: {
      type: Number,
      required: true,
    },
  },

  data: function () {
    return {
      min: 0,
      max: 100,
    };
  },

  computed: {
    /**
     * Get the offered price.
     *
     * @returns {number}
     */
    offer () {
      return this.item.sale || this.item.price;
    },

    /**
     * Get the total price.
     *
     * @returns {number}
     */
    total () {
      return this.offer * this.quantity;
    }
  },

  methods: {
    /**
     * Decrement the item quantity.
     */
    decrement () {
      if (this.quantity > this.min) {
        this.$emit('update:quantity', this.quantity - 1);
      }
    },

    /**
     * Update the item quantity.
     *
     * @param {number} quantity
     */
    update (quantity) {
      quantity = Number(quantity);

      if (this.min <= quantity && quantity <= this.max) {
        this.$emit('update:quantity', quantity);
      }
    },

    /**
     * Increment the item quantity.
     */
    increment () {
      if (this.quantity < this.max) {
        this.$emit('update:quantity', this.quantity + 1);
      }
    }
  }
};
</script>
